import {API} from '../../Services/Api'
const request = new API()

export const saveTable = (data) => {
  const headers = {'Content-Type': 'multipart/form-data'}
  const form = new FormData()
  form.append('file', data.file)
  form.append('options', JSON.stringify({headers: data.headers, columns: {...data.columns}}))

  return request.api.post('/excels/save_file', form, {headers})
}
